import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private _httpClient = inject(HttpClient);

    getTranslation(lang: string): Observable<Translation> {
        const path = `/i18n/${lang}.json`;
        return this._httpClient.get<Translation>(path);
    }
}

